<template lang="pug">
.HabitsContainer
  h2.HabitsTitle Enter the time you will spend in habits and calculate the detailed remaining time
  table.table.is-bordered.is-striped
    tr
      th Habits 
      td Your habits done daily, weekly, monthly.
    tr
      th Habits Type 
      td Choose a habits interval, such as daily, weekly, or monthly.
    tr
      th Time 
      td Set the unit for multiplying by "Habit Type". For example, if you select "Daily" and enter "15 minutes", it will be calculated as "365 x 15min".
    tr
      th Time Type 
      td A unit of time. It has "seconds" "minutes" "hours" "days"
    
  .RegistedHabitsContainer(v-if="getHabits.length > 0")
    table.table.is-bordered.is-striped
      thead
        tr
          th Habit
          th Interval 
          th Times
          th Day / Year
      tbody
        tr(v-for="(h, index) in getHabits" :key="index")
          td {{h.name}}
          td {{h.habitTypeDisplayName}}
          td {{h.time}} {{h.timeTypeDisplayName}}
          td {{h.caluclated}} / 365

  .HabitsInputItemContainer.columns
    .HabitsItem.column
      .control.has-icons-left
        input.input(placeholder="Habits" v-model="habits")
        span.icon.is-left
          i.mdi.mdi-account
    .HabitsItem.column
      .field
        .control
          .select
            select(v-model="habitsType")
              option(disabled value="") Habits Type 
              option(value="1") Daily
              option(value="2") Weekly
              option(value="3") Monthly
    .HabitsItem.column
      .control.has-icons-left
        input.input(placeholder="Time" v-model="Timeval" type="tel")
        span.icon.is-left
          i.mdi.mdi-alarm
    .HabitsItem.column
      .field
        .control.is-expanded
          .select
            select(v-model="timeType")
              option(disabled value="") Time Type 
              option(value="1") sec 
              option(value="2") min 
              option(value="3") hour 
              option(value="4") day
    .HabitsItem.column
      a.button.is-primary.is-fullwidth(@click="registerHabits")
        span.icon.is-small
          i.mdi.mdi-check
        span Register

</template>

<script>
export default {
  name: 'Habits',
  data(){
    return {
      habits: '',
      habitsType: '',
      timeval: '',
      timeType: '',
    }
  },
  computed: {
    Habits: {
      get(){
        return this.habits
      },
      set(val){
        this.habits = val
      }
    },
    Timeval: {
      get(){
        return this.timeval
      },
      set(val){
        this.timeval = val
      },
    },
    getHabits(){
      return this.$store.getters['losstime/getHabits']
    }
  },
  methods: {
    /*
    saveHabits(ev){
      this.habits = ev.target.value
    },
    */
    saveTime(ev){
      this.time = ev.target.value
    },
    async registerHabits(){
      let nullError = ""
      if(!this.habits || this.habits.length === 0 || this.habits === ""){
        nullError += 'Habit Name'
      }
      if(!this.Timeval || parseInt(this.Timeval) <= 0){
        nullError += 'Time'
      }
      if(!this.habitsType || parseInt(this.habitsType) > 3 || parseInt(this.habitsType) <= 0){
        nullError += 'Habits Type'
      }
      if(!this.timeType || parseInt(this.timeType) > 4 || parseInt(this.timeType) <= 0){
        nullError += 'Time Type'
      }
      if (nullError || nullError.length > 0) {
        return
      } else {
        await this.$store.dispatch('losstime/setHibit', {habitName: this.habits, habitType: this.habitsType, time: this.Timeval, timeType: this.timeType})
      }
      this.habits = ''
      this.habitsType = ''
      this.Timeval = ''
      this.timeType = '' 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.HabitsContainer
  width: 90%
  margin: 80px auto
  .HabitsTitle
    font-size: 1.1rem
    font-weight: bolder
    color: #1b46a8
  .table
    margin-top: 20px
    th
      white-space: nowrap
  .HabitsInputItemContainer
    padding: 20px
    background-color: #F7F7F7
    border: 1px solid #EEE
    margin-top: 20px
    .HabitsItem
      .select
        width: 100%
        select
          width: 100%
  .RegistedHabitsContainer
    .table
      width: 100%
</style>
